import React, { Component } from "react"
import Async from "react-select"
import Field from "../../Common/Field/Field"
import Button from "../../Buttons/Button"
import ModuleHeader from "../ModuleHeader"
import ButtonIcon from "../../Costing/Button/ButtonIcon"

export default class SampleModule extends Component {
  state = {
    _id: "",
    sample: [],
    SAMPLEREQUEST: {},
    STATUS: [],
    assignedToList: [],
    disabled: false
  }

  componentWillMount() {
    let {
      sample,
      _id,
      SAMPLEREQUEST,
      disabled,
      assignedToList,
      sampleProcess,
      sizeList
    } = this.props

    this.setState({
      sample,
      _id,
      SAMPLEREQUEST,
      disabled,
      sampleProcess,
      assignedToList,
      sizeList
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(this.state.SAMPLEREQUEST).length !=
      Object.keys(nextProps.SAMPLEREQUEST).length
    ) {
      this.setState({
        SAMPLEREQUEST: nextProps.SAMPLEREQUEST
      })
    }
    if (this.state.STATUS.length != nextProps.STATUS.length) {
      this.setState({
        STATUS: nextProps.STATUS
      })
    }

    if (this.state.assignedToList.length != nextProps.assignedToList.length) {
      this.setState({
        assignedToList: nextProps.assignedToList
      })
    }

    const { sample, _id, disabled, sampleProcess, sizeList } = nextProps
    this.setState({
      sample,
      sampleProcess,
      sizeList,
      _id,
      disabled
    })
  }

  render() {
    const { sample, SAMPLEREQUEST, STATUS, assignedToList } = this.state
    const { permissions } = this.props

    return (
      <div
        class="col-md-12 nopadding"
        id="sample"
        style={{ marginBottom: ".5%" }}
      >
        <ModuleHeader
          header={"Sample"}
          moduleName={"sample"}
          onClick={this.openModal}
          _id={this.state._id}
          process={this.props.sampleProcess}
          statusList={STATUS}
          updateModulesMain={this.props.updateModulesMain}
          disabled={this.props.disabled}
        />
        <form name="sampleForm">
          <div class="col-md-12 nopadding">
            <div class="col-md-2">
              <Field
                isFormGroup={true}
                inputType="checkboxToggle"
                inputName="awaitingDevSample"
                value={sample.awaitingDevSample}
                label="Awaiting Dev Sample"
                onChange={this.props.getSample}
                disabled={this.state.disabled}
              />
            </div>
            <div class="col-md-2">
              <Field
                isFormGroup={true}
                inputType="checkboxToggle"
                inputName="awaitingDevSheet"
                value={sample.awaitingDevSheet}
                label="Awaiting Design Sheet"
                onChange={this.props.getSample}
                disabled={this.state.disabled}
              />
            </div>
          </div>
          <div className="col-md-12 nopadding">
            <div className="col-md-1 inline-center">
              <label>Sizes</label>
              {!this.state.disabled &&
                (permissions.create || permissions.edit) && (
                  <ButtonIcon
                    buttonType="add"
                    addRemoveFunc={() => this.props.addSize()}
                  />
                )}
            </div>
          </div>
          <div class="col-md-12">
            <div className="main-sample-size-box">
              <div className="row">
                {sample.data.map((data, i) => (
                  <div
                    key={i}
                    class="col-md-4 size-mngr size-mngr-mod pl-0 mb-4"
                  >
                    <div class="col-4-shadow px-0">
                      <div class="col-md-5 step-one">
                        <div class="form-group mb-3">
                          <label for="address">Size</label>
                          <Field
                            isFormGroup={false}
                            inputType="select"
                            inputName="size"
                            value={data.size}
                            index={i}
                            onChange={this.props.getSample}
                            options={this.state.sizeList}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                      <div class="col-md-5 step-one">
                        <div class="form-group mb-3">
                          <label for="address">Qty</label>
                          <input
                            type="number"
                            min="0"
                            value={data.quantity}
                            disabled={this.state.disabled}
                            onChange={e =>
                              this.props.getSample(
                                e.target.name,
                                e.target.value,
                                i
                              )
                            }
                            class="form-control"
                            name="quantity"
                          />
                        </div>
                      </div>
                      {!this.state.disabled &&
                        (permissions.create || permissions.edit) && (
                          <div
                            class="col-md-2 add-address"
                            style={{ top: "18px" }}
                          >
                            <ButtonIcon
                              buttonType="clear"
                              addRemoveFunc={() => this.props.removeSize(i)}
                            />
                          </div>
                        )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <Field
              isFormGroup={true}
              inputType={"textarea"}
              inputName={"comments"}
              value={sample.comments}
              label={"comments"}
              onChange={this.props.getSample}
              disabled={this.state.disabled}
            />
          </div>
          {!this.state.disabled && (permissions.create || permissions.edit) && (
            <div class="col-md-12 no-padding text-center profile-btn">
              <Button
                buttonName={"save"}
                onClick={e => this.props.createSampleModule(e)}
              />
              <Button
                buttonName={"Complete"}
                onClick={e => this.props.completeSampleModule(e)}
              />
            </div>
          )}
        </form>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/SampleModule/index.js